export const lineArr = {
  lineInfoLeft_0: {
    id: 'left_0',
    colors: ['#d8dbe3', '#d8dbe3', '#d8dbe3'], // 渐变
    canvasWidth: 88, // 宽度
    canvasHeight: 38, // 高度
    step: 1, // 运动速度
    space: 100, // 光标的间隔
    curterWidth: 7, // 光标宽度
    curveLineWidth: 14, // 管道宽度
    curterlength: 40, // 光标长度
    shadowOpcity: '0.3',
    stop: false,
    shadowColor: '255,255,255',
    points: [
      // 整体路径
      {
        // 起始点
        x: 258,
        y: 653,
      },
      {
        // 转折点
        x: 127,
        y: 653,
      },
      {
        // 转折点
        x: 127,
        y: 698,
      },
    ],
  },
  lineInfoLeft_1: {
    id: 'left_1',
    colors: ['#d8dbe3', '#d8dbe3', '#d8dbe3'], // 渐变
    canvasWidth: 135, // 宽度
    canvasHeight: 14, // 高度
    step: 1.5, // 运动速度
    space: 100, // 光标的间隔
    curterWidth: 7, // 光标宽度
    curveLineWidth: 14, // 管道宽度
    curterlength: 60, // 光标长度
    shadowOpcity: '0.3',
    stop: false,
    shadowColor: '255,255,255',
    points: [
      // 整体路径
      {
        // 起始点
        x: 790,
        y: 420,
      },
      {
        // 转折点
        x: 600,
        y: 420,
      },
    ],
  },
  lineInfoLeft_2: {
    id: 'left_2',
    colors: ['#d8dbe3', '#d8dbe3', '#d8dbe3'], // 渐变
    canvasWidth: 135, // 宽度
    canvasHeight: 14, // 高度
    step: 1.5, // 运动速度
    space: 100, // 光标的间隔
    curterWidth: 7, // 光标宽度
    curveLineWidth: 14, // 管道宽度
    curterlength: 60, // 光标长度
    shadowOpcity: '0.3',
    stop: false,
    shadowColor: '255,255,255',
    points: [
      // 整体路径
      {
        // 起始点
        x: 790,
        y: 585,
      },
      {
        // 转折点
        x: 600,
        y: 585,
      },
    ],
  },
  lineInfoLeft_3: {
    id: 'left_3',
    colors: ['#d8dbe3', '#d8dbe3', '#d8dbe3'], // 渐变
    canvasWidth: 135, // 宽度
    canvasHeight: 14, // 高度
    step: 1.5, // 运动速度
    space: 100, // 光标的间隔
    curterWidth: 7, // 光标宽度
    curveLineWidth: 14, // 管道宽度
    curterlength: 60, // 光标长度
    shadowOpcity: '0.3',
    stop: false,
    shadowColor: '255,255,255',
    points: [
      // 整体路径
      {
        // 起始点
        x: 790,
        y: 720,
      },
      {
        // 转折点
        x: 600,
        y: 720,
      },
    ],
  },
  lineInfoLeft_4: {
    id: 'left_4',
    colors: ['#d8dbe3', '#d8dbe3', '#d8dbe3'], // 渐变
    canvasWidth: 135, // 宽度
    canvasHeight: 14, // 高度
    step: 1.5, // 运动速度
    space: 100, // 光标的间隔
    curterWidth: 7, // 光标宽度
    curveLineWidth: 14, // 管道宽度
    curterlength: 60, // 光标长度
    shadowOpcity: '0.3',
    stop: false,
    shadowColor: '255,255,255',
    points: [
      // 整体路径
      {
        // 起始点
        x: 790,
        y: 860,
      },
      {
        // 转折点
        x: 600,
        y: 860,
      },
    ],
  },
  lineInfoLeft_5: {
    id: 'left_5',
    colors: ['#d8dbe3', '#d8dbe3', '#d8dbe3'], // 渐变
    canvasWidth: 120, // 宽度
    canvasHeight: 14, // 高度
    step: 1.5, // 运动速度
    space: 80, // 光标的间隔
    curterWidth: 7, // 光标宽度
    curveLineWidth: 14, // 管道宽度
    curterlength: 60, // 光标长度
    shadowOpcity: '0.3',
    stop: false,
    shadowColor: '255,255,255',
    points: [
      // 整体路径
      {
        // 起始点
        x: 790,
        y: 420,
        color: '#d8dbe3', // 单独某段渐变的起点
        isStart: false,
      },
      {
        // 转折点
        x: 950,
        y: 420,
        color: '#FF0D0D', // 单独某段渐变的终点
        isEnd: false,
      },
    ],
  },
  lineInfoLeft_6: {
    id: 'left_6',
    colors: ['#d8dbe3', '#d8dbe3', '#d8dbe3'], // 渐变
    canvasWidth: 62, // 宽度
    canvasHeight: 180, // 高度
    step: 1, // 运动速度
    space: 120, // 光标的间隔
    curterWidth: 7, // 光标宽度
    curveLineWidth: 14, // 管道宽度
    curterlength: 60, // 光标长度
    shadowOpcity: '0.3',
    stop: false,
    shadowColor: '255,255,255',
    points: [
      // 整体路径
      {
        // 起始点
        x: 1190,
        y: 350,
      },
      {
        // 起始点
        x: 1310,
        y: 350,
      },
      {
        // 起始点
        x: 1310,
        y: 325,
      },
      {
        // 起始点
        x: 1350,
        y: 325,
      },
    ],
  },
  lineInfoLeft_7: {
    id: 'left_7',
    colors: ['#d8dbe3', '#d8dbe3', '#d8dbe3'], // 渐变
    canvasWidth: 62, // 宽度
    canvasHeight: 180, // 高度
    step: 1.5, // 运动速度
    space: 120, // 光标的间隔
    curterWidth: 7, // 光标宽度
    curveLineWidth: 14, // 管道宽度
    curterlength: 40, // 光标长度
    shadowOpcity: '0.3',
    stop: false,
    shadowColor: '255,255,255',
    points: [
      // 整体路径
      {
        // 起始点
        x: 1190,
        y: 350,
      },
      {
        // 起始点
        x: 1310,
        y: 350,
      },
      {
        // 起始点
        x: 1310,
        y: 390,
      },
      {
        // 起始点
        x: 1350,
        y: 390,
      },
    ],
  },
  lineInfoLeft_8: {
    id: 'left_8',
    colors: ['#d8dbe3', '#d8dbe3', '#d8dbe3'], // 渐变
    canvasWidth: 197, // 宽度
    canvasHeight: 552, // 高度
    step: 2, // 运动速度
    space: 120, // 光标的间隔
    curterWidth: 7, // 光标宽度
    curveLineWidth: 14, // 管道宽度
    curterlength: 60, // 光标长度
    shadowOpcity: '0.3',
    stop: false,
    shadowColor: '255,255,255',
    points: [
      // 整体路径
      {
        // 起始点
        x: 1190,
        y: 350,
      },
      {
        // 起始点
        x: 1310,
        y: 350,
      },
      {
        // 起始点
        x: 1310,
        y: 455,
      },
      {
        // 转折点
        x: 1370,
        y: 455,
      },
      {
        // 转折点
        x: 1370,
        y: 560,
      },
      {
        // 转折点
        x: 1265,
        y: 560,
      },
      {
        // 转折点
        x: 1265,
        y: 830,
      },
    ],
  },
  lineInfoLeft_9: {
    id: 'left_9',
    colors: ['#d8dbe3', '#d8dbe3', '#d8dbe3'], // 渐变
    canvasWidth: 14, // 宽度
    canvasHeight: 227, // 高度
    step: 1.5, // 运动速度
    space: 100, // 光标的间隔
    curterWidth: 7, // 光标宽度
    curveLineWidth: 14, // 管道宽度
    curterlength: 60, // 光标长度
    shadowOpcity: '0.3',
    stop: false,
    shadowColor: '255,255,255',
    points: [
      // 整体路径

      {
        // 转折点
        x: 1195,
        y: 530,
      },
      {
        // 转折点
        x: 1195,
        y: 830,
      },
    ],
  },
  lineInfoLeft_10: {
    id: 'left_10',
    colors: ['#d8dbe3', '#d8dbe3', '#d8dbe3'], // 渐变
    canvasWidth: 14, // 宽度
    canvasHeight: 100, // 高度
    step: 1, // 运动速度
    space: 70, // 光标的间隔
    curterWidth: 7, // 光标宽度
    curveLineWidth: 14, // 管道宽度
    curterlength: 40, // 光标长度
    shadowOpcity: '0.3',
    stop: false,
    shadowColor: '255,255,255',
    points: [
      // 整体路径

      {
        // 转折点
        x: 1195,
        y: 530,
      },
      {
        // 转折点
        x: 1195,
        y: 430,
      },
    ],
  },
  lineInfoLeft_11: {
    id: 'left_11',
    colors: ['#d8dbe3', '#d8dbe3', '#d8dbe3'], // 渐变
    canvasWidth: 60, // 宽度
    canvasHeight: 170, // 高度
    step: 1, // 运动速度
    space: 60, // 光标的间隔
    curterWidth: 7, // 光标宽度
    curveLineWidth: 14, // 管道宽度
    curterlength: 50, // 光标长度
    shadowOpcity: '0.3',
    stop: false,
    shadowColor: '255,255,255',
    points: [
      // 整体路径
      {
        // 起始点
        x: 1190,
        y: 810,
      },
      {
        // 起始点
        x: 1310,
        y: 810,
      },
      {
        // 起始点
        x: 1310,
        y: 780,
      },
      {
        // 起始点
        x: 1350,
        y: 780,
      },
    ],
  },
  lineInfoLeft_12: {
    id: 'left_12',
    colors: ['#d8dbe3', '#d8dbe3', '#d8dbe3'], // 渐变
    canvasWidth: 60, // 宽度
    canvasHeight: 170, // 高度
    step: 1, // 运动速度
    space: 60, // 光标的间隔
    curterWidth: 7, // 光标宽度
    curveLineWidth: 14, // 管道宽度
    curterlength: 50, // 光标长度
    shadowOpcity: '0.3',
    stop: false,
    shadowColor: '255,255,255',
    points: [
      // 整体路径
      {
        // 起始点
        x: 1190,
        y: 810,
      },
      {
        // 起始点
        x: 1310,
        y: 810,
      },
      {
        // 起始点
        x: 1310,
        y: 845,
      },
      {
        // 起始点
        x: 1350,
        y: 845,
      },
    ],
  },
  lineInfoLeft_13: {
    id: 'left_13',
    colors: ['#d8dbe3', '#d8dbe3', '#d8dbe3'], // 渐变
    canvasWidth: 60, // 宽度
    canvasHeight: 170, // 高度
    step: 1, // 运动速度
    space: 100, // 光标的间隔
    curterWidth: 7, // 光标宽度
    curveLineWidth: 14, // 管道宽度
    curterlength: 50, // 光标长度
    shadowOpcity: '0.3',
    stop: false,
    shadowColor: '255,255,255',
    points: [
      // 整体路径
      {
        // 起始点
        x: 1190,
        y: 810,
      },
      {
        // 起始点
        x: 1310,
        y: 810,
      },
      {
        // 起始点
        x: 1310,
        y: 910,
      },
      {
        // 起始点
        x: 1350,
        y: 910,
      },
    ],
  },
  lineInfoLeft_14: {
    id: 'left_14',
    colors: ['#d8dbe3', '#d8dbe3', '#d8dbe3'], // 渐变
    canvasWidth: 140, // 宽度
    canvasHeight: 140, // 高度
    step: 1, // 运动速度
    space: 140, // 光标的间隔
    curterWidth: 7, // 光标宽度
    curveLineWidth: 14, // 管道宽度
    curterlength: 50, // 光标长度
    shadowOpcity: '0.3',
    stop: false,
    shadowColor: '255,255,255',
    points: [
      // 整体路径
      {
        // 起始点
        x: 1040,
        y: 530,
        color: '#d8dbe3', // 单独某段渐变的起点
        isStart: false,
      },
      {
        // 起始点
        x: 1040,
        y: 670,
        color: '#FF0D0D', // 单独某段渐变的终点
        isEnd: false,
      },
    ],
  },
  lineInfoLeft0: {
    id: 'left1',
    colors: ['#58B7F4', '#2B6BF2'], // 渐变
    colorsLevel: [0, 0.2],
    LinearGradient: {
      // 设置管道渐变起终点
      x0: 0,
      y0: 390,
      x1: 720,
      y1: 0,
    },
    canvasWidth: 390, // 宽度
    canvasHeight: 720, // 高度
    step: 3, // 运动速度
    space: 180, // 光标的间隔
    curterlength: 60, // 光标长度
    curterWidth: 7, // 光标宽度
    curveLineWidth: 14, // 管道宽度
    shadowOpcity: '0.8',
    stop: false,
    shadowColor: '255,255,255',
    points: [
      // 整体路径
      {
        // 起始点
        x: 230,
        y: 920,
      },
      {
        // 转折点
        x: 230,
        y: 980,
      },
      {
        // 转折点
        x: 443,
        y: 980,
      },
      {
        // 转折点
        x: 443,
        y: 340,
      },
      {
        // 结束点
        x: 540,
        y: 340,
      },
    ],
  },
  lineInfoLeft1: {
    id: 'left',
    colors: ['#4598f3', '#2b6ef1'], // 渐变
    colorsLevel: [0, 0.9],
    canvasWidth: 428, // 宽度
    canvasHeight: 827, // 高度
    step: 2.5, // 运动速度
    space: 160, // 光标的间隔
    curterlength: 60, // 光标长度
    curterWidth: 7, // 光标宽度
    curveLineWidth: 14, // 管道宽度
    shadowOpcity: '0.8',
    stop: false,
    shadowColor: '255,255,255',
    points: [
      // 整体路径
      {
        // 起始点
        x: 540,
        y: 340,
      },
      {
        // 转折点
        x: 680,
        y: 340,
        color: '#2b6ef1', // 单独某段渐变的起点
        isStart: false,
      },
      {
        x: 680,
        y: 255,
      },
      {
        x: 790,
        y: 255,
        color: '#FF0D0D', // 单独某段渐变的终点
        isEnd: false,
      },

      {
        x: 790,
        y: 255,
        color: '#FF0D0D', // 单独某段渐变的起点
        isStart: false,
      },
      {
        x: 790,
        y: 450,
        color: '#2b6ef1', // 单独某段渐变的起点
        isEnd: false,
      },
      {
        x: 790,
        y: 930,
      },
      {
        x: 790,
        y: 930,
        color: '#2b6ef1',
        isStart: false,
      },
      {
        x: 940,
        y: 930,
        color: '#FF0D0D',
        isEnd: false,
      },
      // {
      //   x: 940,
      //   y: 550
      // },
      // {
      //   x: 1040,
      //   y: 550
      // }
    ],
    LinearGradient: {
      x0: 0,
      y0: 0,
      x1: 428,
      y1: 827,
    },
    // LinearGradient:{
    //   x0:300,
    //   y0:0,
    //   x1:314,
    //   y1:10
    // }
  },
  lineInfoLeft2: {
    id: 'left3',
    colors: ['#2b6bf2', '#2b6bf2'], // 渐变
    colorsLevel: [0, 0.9],
    canvasWidth: 50, // 宽度
    canvasHeight: 480, // 高度
    step: 2.5, // 运动速度
    space: 200, // 光标的间隔
    curterlength: 50, // 光标长度
    curterWidth: 7, // 光标宽度
    curveLineWidth: 14, // 管道宽度
    shadowOpcity: '0.8',
    stop: false,
    shadowColor: '255,255,255',
    points: [
      // 整体路径

      {
        x: 940,
        y: 930,
        color: '#FF0D0D', // 单独某段渐变的起点
        isStart: false,
      },
      {
        x: 940,
        y: 555,
        color: '#2b6bf2', // 单独某段渐变的起点
        isEnd: false,
      },
      {
        x: 1040,
        y: 555,
      },
    ],
    // LinearGradient:{
    //   x0:0,
    //   y0:480,
    //   x1:50,
    //   y1:0
    // }
  },
  lineInfoLeft3: {
    id: 'left4',
    colors: ['#FFB94F', '#1eb675'], // 渐变
    colorsLevel: [0, 0.1],
    canvasWidth: 655, // 宽度
    canvasHeight: 450, // 高度
    step: 2.5, // 运动速度
    space: 160, // 光标的间隔
    curterlength: 50, // 光标长度
    curterWidth: 7, // 光标宽度
    curveLineWidth: 14, // 管道宽度
    shadowOpcity: '0.8',
    stop: false,
    shadowColor: '255,255,255',
    points: [
      // 整体路径
      {
        // 起始点
        x: 990,
        y: 543,
      },
      {
        // 转折点
        x: 1120,
        y: 543,
      },
      {
        // 转折点
        x: 1120,
        y: 350,
      },
      {
        // 转折点
        x: 1310,
        y: 350,
      },
      {
        // 转折点
        x: 1310,
        y: 260,
      },
      {
        // 转折点
        x: 1500,
        y: 260,
      },
      {
        // 转折点
        x: 1500,
        y: 520,
      },
      {
        // 转折点
        x: 1195,
        y: 520,
      },
      {
        // 转折点
        x: 1195,
        y: 610,
      },
      {
        // 转折点
        x: 1550,
        y: 610,
        color: '#1eb675', // 单独某段渐变的起点
        isStart: true,
      },
      {
        // 转折点
        x: 1595,
        y: 610,
        color: '#f1b552', // 单独某段渐变的起点
        isEnd: true,
      },
    ],
    LinearGradient: {
      x0: 655,
      y0: 0,
      x1: 550,
      y1: 10,
    },
  },
  lineInfoLeft4: {
    id: 'left5',
    colors: ['#1eb675', '#1eb675'], // 渐变
    colorsLevel: [0, 0.9],
    canvasWidth: 537, // 宽度
    canvasHeight: 317, // 高度
    step: 2.5, // 运动速度
    space: 140, // 光标的间隔
    curterlength: 50, // 光标长度
    curterWidth: 7, // 光标宽度
    curveLineWidth: 14, // 管道宽度
    shadowOpcity: '0.8',
    stop: false,
    shadowColor: '255,255,255',
    points: [
      // 整体路径
      {
        // 起始点
        x: 990,
        y: 565,
      },
      {
        // 转折点
        x: 1120,
        y: 565,
      },
      {
        // 转折点
        x: 1120,
        y: 810,
      },
      {
        // 转折点
        x: 1310,
        y: 810,
      },
      {
        // 转折点
        x: 1310,
        y: 710,
      },
      {
        // 转折点
        x: 1500,
        y: 710,
      },
      {
        // 转折点
        x: 1500,
        y: 610,
      },
    ],
    // LinearGradient:{
    //   x0:0,
    //   y0:480,
    //   x1:50,
    //   y1:0
    // }
  },
};

export const detailConfig = [
  {
    prop: 'rank',
    label: '日期',
    fixed: 'left',
  },
  {
    prop: 'rate',
    label: '预警指标',
    width: '113',
  },
  {
    prop: 'start_time',
    label: '预警规则',
    width: '131',
  },
  {
    prop: 'outsourcer',
    label: '供应商',
    width: '120',
  },
  {
    prop: 'product',
    label: '产线',
    width: '120',
  },
  {
    prop: 'operator_name',
    label: '人员',
    min_width: '225',
  },
];

export const tipconfig = {
  // 绩效评价
  achievementsTip: `绩效评价反映的是作业员的作业表现，满分100分，以产线+角色的维度计算分数。该维度下设四小项：质量、效率、产量、有效时长，每项满分100，根据每项作业员的达标比（作业员实际指标值/产线标准值）计算分数，总分为各小项的加权平均值。<br>
  <br>
  <b>质量</b>（权重：40%）<br>
  说明：达标比=0时，该项得分为100分；达标比=1时，该项得分为60分；达标比=2时，该项得分为0分；达标比为中间值时，按以上关键比值与分数的关系用二次函数拟合后的公式计算。<br>
  例：某产线标准质量为0.1%，该产线某作业员的质量指标值：<br>
  1）为0的时候，得100分；<br>
  2）为0.05%的时候，按照公式计算，为83分；<br>
  3）为0.1%的时候，得60分；<br>
  4）为0.15%的时候，按照公式计算，为33分；<br>
  5）高于0.2%，得0分；<br>
  计算公式：<br>
  当达标比为x时，<br>
  x=0：质量得分=100<br>
  0＜x＜2：质量得分=   -10*x^2 - 30*x + 100<br>
  x≥2：质量得分=0<br>
  <br>
  <b>效率</b>（权重：30%）<br>
  说明：达标比=2时，该项得分为100分；达标比=1时，该项得分为60分；达标比=0时，该项得分为0分；达标比为中间值时，按以上关键比值与分数的关系用二次函数拟合后的公式计算。<br>
  例：某产线标准效率为1000，该产线某作业员的效率指标值：<br>
  1）为0的时候，得0分；为500的时候，按照公式计算，为33分；<br>
  2）为500的时候，按照公式计算，为33分；<br>
  3）为1000的时候，得60分；<br>
  4）为1500的时候，按照公式计算，为83分；<br>
  5）高于2000，得100分；<br>
  计算公式：<br>
  当达标比为x时，<br>
  公式：当标准比值=x时，<br>
  x＜2：效率得分= -10*x^2 + 70*x<br>
  x≥2：效率得分=100<br>
  <br>
  <b>产量</b>（权重：15%）<br>
  说明：达标比=2时，该项得分为100分；达标比=1时，该项得分为60分；达标比=0时，该项得分为0分；达标比为中间值时，按以上关键比值与分数的关系用二次函数拟合后的公式计算。<br>
  例：某产线标准产量为1000，该产线某作业员的产量指标值：<br>
  1）为0的时候，得0分；为500的时候，按照公式计算，为33分；<br>
  2）为500的时候，按照公式计算，为33分；<br>
  3）为1000的时候，得60分；<br>
  4）为1500的时候，按照公式计算，为83分；<br>
  5）高于2000，得100分；<br>
  计算公式：<br>
  当达标比为x时，<br>
  公式：当标准比值=x时，<br>
  x＜2：产量得分= -10*x^2 + 70*x<br>
  x≥2：产量得分=100<br>
  <br>
  <b>时长</b>（权重：15%）<br>
  说明：达标比=2时，该项得分为100分；达标比=1时，该项得分为60分；达标比=0时，该项得分为0分；达标比为中间值时，按以上关键比值与分数的关系用二次函数拟合后的公式计算。<br>
  例：某产线标准时长为7，该产线某作业员的时长指标值：<br>
  1）为0的时候，得0分；<br>
  2）为4.9的时候，按照公式计算，为36分；<br>
  3）为7的时候，得60分；<br>
  4）为8.4的时候，按照公式计算，为79分；<br>
  5）高于9.8，得100分；<br>
  计算公式：<br>
  当达标比为x时，<br>
  公式：当标准比值=x时，<br>
  x＜1.4：耗时得分=28.571*x^2 + 31.429*x <br>
  x≥1.4：耗时得分=100<br>
  `,
  // 潜力评价
  potentialTip: `潜力评价反映的是作业员的发展空间，满分五星。该维度下设五小项：理论、实践、技能、稳定、积极，每项满分五星，总分为各小项的平均值。该维度在评价时各项指标均不分产线统一计算。<br>
  <br>
  <b>理论：</b>使用常春腾历史一次考试通过率作为关键指标<br>
  0%~20%：★<br>
  20%~40%：★★<br>
  40%~60%：★★★<br>
  60%~80%：★★★★<br>
  80:%~100%：★★★★★<br>
  <br>
  <b>实践：</b>使用达标周期平均值作为关键指标<br>
  达标周期：初次进入产线时连续5个工作日达到标准效率，取第5天为达标日，计算从投产到达标日的工作天数。<br>
  例：小明于1101初次进入交限产线作业，每周日休息；其中1109~1111达到标效，1112未达到标效，则不算达标；1122~1126达到标效，则以1126为达标日，达标周期为1101~1126期间的所有工作日之和，计数可得23天。<br>
  有多个达标周期时，取平均值（保留两位小数）计算。<br>
  ≥42：★<br>
  30≤x＜42：★★<br>
  18≤x＜30：★★★<br>
  6≤x＜18：★★★★<br>
  ＜6：★★★★★<br>
  <br>
  <b>技能：</b>使用作业员历史作业过的产线数量作为关键指标<br>
  1：★<br>
  2：★★<br>
  3：★★★<br>
  4：★★★★<br>
  ≥5：★★★★★<br>
  <br>
  <b>稳定：</b>使用作业评价自然周环比作为关键指标<br>
  每个自然周的周一计算上周绩效得分和上上周绩效得分的环比（保留两位小数）；计算时，取截止日期前5周的周环比求平均。<br>
  例：计算1223的稳定评价时，取1121、1128、1205、1212、1219四天计算的周环比绝对值求平均；<br>
  ＞10%：★<br>
  7.5%≤x＜10%：★★<br>
  5%≤x＜7.5%：★★★<br>
  2.5%≤x＜5%：★★★★<br>
  ≤2.5%：★★★★★<br>
  <br>
  <b>积极：</b>使用有效评价数量作为关键指标<br>
  ＜10：★<br>
  10≤x＜15：★★<br>
  15≤x＜20：★★★<br>
  20≤x＜25：★★★★<br>
  ≥25：★★★★★<br>
  `,
};

